import Vue from 'vue'
import Vuex from 'vuex'

/* Theme Core */
import verticalMenu from './vertical-menu'
import appConfig from './app-config'
import app from './app'
/* App Core */
import users from './Admin/Core/users'
import userTypes from './Admin/Core/user_types'
import smtpConfig from './Admin/Core/smtpconfig'
import abilities from './Admin/Core/abilities'
import cropperUploads from './Admin/Core/cropper_uploads'
import fileUpload from './Admin/Core/file_upload'
/* App Data */
import about from './Admin/App/about'
import aboutItems from './Admin/App/about_items'
import collectionsItems from './Admin/App/collections_items'
import sustainability from './Admin/App/sustainability'
import sustainabilityItems from './Admin/App/sustainability_items'
import blog from './Admin/App/blog'
import blogCategories from './Admin/App/blog_categories'
import carousel from './Admin/App/carousel'
import components from './Admin/App/components'
import contacts from './Admin/App/contacts'
import contents from './Admin/App/contents'
import certificates from './Admin/App/certificates'
import dealers from './Admin/App/dealers'
import imageGallery from './Admin/App/image_gallery'
import hrPositions from './Admin/App/hr_positions'
import webforms from './Admin/App/webforms'
import history from './Admin/App/history'
import menus from './Admin/App/menus'
import overview from './Admin/App/overview'
import popupImages from './Admin/App/popup_images'
import references from './Admin/App/references'
import socialMedia from './Admin/App/socialmedia'
import siteConfig from './Admin/App/site_config'
import translate from './Admin/App/translate'
import whatsapp from './Admin/App/whatsapp'
import collections from './Admin/App/collections'
import production from './Admin/App/production'
import productionItems from './Admin/App/production_items'
import productsItems from './Admin/App/products_items'
import products from './Admin/App/products'
import productGroups from './Admin/App/product_groups'
import productReynaersCat from './Admin/App/product_reynaers_cat'
import productParameters from './Admin/App/product_parameters'
import productsReynaersItems from './Admin/App/products_reynaers_items'
import productsReynaersTech from './Admin/App/products_reynaers_tech'
/* App Defines */
import  menuTypes from './Admin/Defines/menu_types'

import features from './Admin/Defines/features'
import featureGroups from './Admin/Defines/feature_groups'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    users,
    userTypes,
    productReynaersCat,
    productsReynaersTech,
    productsItems,
    smtpConfig,
    abilities,
    cropperUploads,
    fileUpload,
    about,
    aboutItems,
    sustainability,
    sustainabilityItems,
    blog,
    blogCategories,
    carousel,
    certificates,
    components,
    contacts,
    contents,
    dealers,
    imageGallery,
    hrPositions,
    webforms,
    history,
    menus,
    overview,
    popupImages,
    references,
    socialMedia,
    siteConfig,
    translate,
    whatsapp,
    menuTypes,
    collections,
    collectionsItems,
    production,
    productionItems,
    products,
    productGroups,
    productParameters,
    features,
    featureGroups,
    productsReynaersItems,
  },
  strict: process.env.DEV,
})
